module.exports = __webpack_public_path__ + "static/Achieva-83ceb795669d6593b53534cbe6b6b401.jpg";